import { Activity, Brain, Heart, Zap, TrendingUp, Shield } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import './Conditions.css';

const Conditions = () => {
  const whatsappUrl = 'https://wa.me/919886332528';

  const conditions = [
    {
      icon: <Activity size={32} />,
      title: 'Back Pain & Spondylosis',
      description: 'Effective treatment for chronic and acute back pain, lumbar spondylosis, and disc problems. Get long-lasting relief with our specialized therapy.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Neck Pain & Cervical Spondylitis',
      description: 'Expert care for neck stiffness, cervical spondylitis, and related headaches. Restore mobility and reduce pain.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Knee Pain & Osteoarthritis',
      description: 'Comprehensive treatment for knee pain, osteoarthritis, and joint degeneration. Improve mobility and reduce inflammation.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Frozen Shoulder',
      description: 'Specialized therapy to restore shoulder movement and reduce pain. Progressive treatment for adhesive capsulitis.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Sciatica & PIVD',
      description: 'Relief from sciatic nerve pain and prolapsed intervertebral disc. Non-surgical treatment options.'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Sports Injuries',
      description: 'Expert rehabilitation for sprains, strains, ligament tears, and other sports-related injuries.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Post-Fracture Rehabilitation',
      description: 'Comprehensive recovery programs after bone fractures. Restore strength and function.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Post-Surgical Rehabilitation',
      description: 'Expert care after orthopedic, cardiac, or general surgery for faster, safer recovery.'
    },
    {
      icon: <Brain size={32} />,
      title: 'Stroke & Paralysis',
      description: 'Neurological rehabilitation to improve mobility, strength, and independence after stroke.'
    },
    {
      icon: <Brain size={32} />,
      title: 'Parkinson\'s Disease',
      description: 'Specialized physiotherapy to manage symptoms and improve quality of life.'
    },
    {
      icon: <Brain size={32} />,
      title: 'Cerebral Palsy',
      description: 'Comprehensive therapy for children and adults with cerebral palsy to improve function.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Carpal Tunnel Syndrome',
      description: 'Non-surgical treatment for hand and wrist pain caused by nerve compression.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Plantar Fasciitis',
      description: 'Effective treatment for heel pain and foot conditions. Restore normal walking.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Tennis Elbow',
      description: 'Treatment for lateral epicondylitis and elbow pain. Restore arm function.'
    },
    {
      icon: <Heart size={32} />,
      title: 'Fibromyalgia',
      description: 'Gentle therapy to manage chronic pain and improve quality of life.'
    },
    {
      icon: <Brain size={32} />,
      title: 'Bell\'s Palsy',
      description: 'Facial nerve rehabilitation to restore facial movement and expression.'
    },
    {
      icon: <Heart size={32} />,
      title: 'Balance Disorders',
      description: 'Vestibular rehabilitation for dizziness, vertigo, and balance problems.'
    }
  ];

  return (
    <div className="conditions-page">
      <div className="page-hero">
        <div className="container">
          <h1>Conditions We Treat</h1>
          <p className="page-subtitle">
            Expert physiotherapy treatment for a wide range of physical conditions in Panjim, Goa
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="intro-text">
            <p>
              At Dr. Manaz's Physiotherapy & Rehabilitation Clinic, we treat a comprehensive range of conditions affecting your muscles, bones, joints, and nervous system. Our certified physiotherapists use evidence-based techniques to help you recover and live pain-free.
            </p>
          </div>

          <div className="conditions-grid-page">
            {conditions.map((condition, index) => (
              <Card key={index} className="condition-card-page">
                <CardContent className="condition-card-content">
                  <div className="condition-icon-page">{condition.icon}</div>
                  <h3>{condition.title}</h3>
                  <p>{condition.description}</p>
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="condition-cta">
                    Book Treatment on WhatsApp
                  </a>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="section-dark cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Don't See Your Condition Listed?</h2>
            <p>We treat many other conditions too. Contact us to discuss your specific needs.</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary large">
              Contact Us on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Conditions;